import { render, staticRenderFns } from "./registerModel.vue?vue&type=template&id=d564190e&scoped=true"
import script from "./registerModel.vue?vue&type=script&lang=js"
export * from "./registerModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d564190e",
  null
  
)

export default component.exports